import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import { Droppable } from 'react-beautiful-dnd'

import ChartSlot from './components/ChartSlot'
import Typography from '../../../UniformComponents/Typography'
import BaseSize from './BaseSize'


const OneByOneLayout = observer(({ store }) => (
    <div className="pp-slide-layout-container">
        <div className="pp-slide-commentary-container">
            <Typography type="tiny" color="grey">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
        </div>

        <br />

        <Droppable key={0} droppableId={`slide-${0}`}>
            {(provided) => (
                <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="pp-chart-slots"
                >
                    <ChartSlot
                        store={store}
                        key={`${store.activeSlide.id}-${0}`}
                        position={0}
                    />
                </div>
            )}
        </Droppable>

        <br />

        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 20 }}>
            <Typography type="tiny">{store.activeSlide.question.has(0) ? store.activeSlide.question.get(0).questionLongText :  i18n.t('question')}</Typography>
            <BaseSize store={store} position={0} />
        </div>
    </div>
))

export default OneByOneLayout
